import React from 'react';
import '../styles/VerifiedSellerBadge.css';

/**
 * Shared verified-seller pill — same design as profile sidebar.
 */
const VerifiedSellerBadge = ({ children, className = '' }) => (
  <span className={`verified-seller-badge${className ? ` ${className}` : ''}`}>
    {children || 'Verified seller'}
  </span>
);

export default VerifiedSellerBadge;
